module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQAMs2l50oAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAA60lEQVRIS72STRLCIAyFwV3P4CFcufRGbt2od0czIc0PkKA4vpk3pSF8j0mbULnUhRHUe55WLvfLZg7iGuo9614S1dSehth3zwLyFp/TdQeIjdqj/dvjKWpKeEg3kKWwZuFwjtboRtjEjSNp+Pl0DPp3zQQwnMHkUFEAggBMIeQfBPAoLHwxQM5Y+0M4SAeMP95iwBhM+hIO4HZEVlNw2GDLGfsBITyX7XrY3Y5iFIDhDrwFw7Nt7P9FBO7A++A+HGQDgluTJXgMB3GAc2spDIjBJB0Q91f4RGOVO28rvH19mVT4G67qDwHolF7q/Ie/C4ajyQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/ranged-icon.png
// module id = 499
// module chunks = 0